export default __webpack_public_path__ + "static/media/glob_indetail_illusHeader_tall375.1d712e16.png";